import { render, staticRenderFns } from "./ShipEugenSeiboldDashboardWidget.vue?vue&type=template&id=bdda4e22&scoped=true"
import script from "./ShipEugenSeiboldDashboardWidget.vue?vue&type=script&lang=js"
export * from "./ShipEugenSeiboldDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./ShipEugenSeiboldDashboardWidget.vue?vue&type=style&index=0&id=bdda4e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdda4e22",
  null
  
)

export default component.exports